import React, { Component } from 'react';
/*import PreLoader from '../common/PreLoader';
import HeaderBar from '../common/HeaderBar';
import GraphicsLayout from "./GraphicsLayout";
import GraphicModal from "./GraphicModal";*/
import * as galleryReducers from "../../reducers/gallery";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as galleryActions from "../../actions/gallery";
//import FilterBar from "../common/FilterBar";
import MainLayout from "../common/MainLayout";

class Graphics extends Component {

    constructor(props) {
        super(props);
        this.state = {
            gal_type: 'VIDEO'
        };
    }


    componentWillMount() {

        let data = {"type" : this.state.gal_type};
        this.props.setGalleryType(data);
    }
    render() {
        return (
            <MainLayout pageName="VIDEO" />
        );
    }
}

function mapStateToProps(state) {

    return {
        galleryUpdate  :galleryReducers.setGalleryUpdate(state)
    };

}
export default  withRouter(connect(mapStateToProps, {
    setGalleryType : galleryActions.setType
})(Graphics));



// WEBPACK FOOTER //
// ./src/components/gallery/Video.js